module.exports = __webpack_public_path__ + "img/faq7.872f546a.png";